/**
 * o16-external-links.js
 * Opens links that leave the store's domain in a new tab (target="_blank"),
 * preserving Referer (rel="noopener" only — never "noreferrer").
 * Internal links (cart, checkout, account, collections, pages, etc.) are
 * left untouched so they keep the current-tab, full-page-load behavior
 * Shopify relies on for cart/checkout state.
 *
 * Controlled globally by:
 *   window.O16_EXTERNAL_NEW_TAB (boolean, default true)
 *   window.O16_INTERNAL_HOSTS   (array of hostnames treated as "internal")
 * Both are emitted inline by layout/theme.liquid before this file loads.
 */
(function () {
  'use strict';

  function getInternalHosts() {
    var hosts = window.O16_INTERNAL_HOSTS;
    if (!Array.isArray(hosts)) hosts = [];
    hosts.push(window.location.host);
    return hosts
      .filter(function (h) { return typeof h === 'string' && h.length; })
      .map(function (h) { return h.toLowerCase(); });
  }

  function mergeRelNoopener(anchor) {
    var rel = (anchor.getAttribute('rel') || '')
      .split(/\s+/)
      .filter(Boolean);

    // Never add noreferrer; strip it out if present so Referer is preserved.
    rel = rel.filter(function (token) {
      return token.toLowerCase() !== 'noreferrer';
    });

    if (rel.map(function (t) { return t.toLowerCase(); }).indexOf('noopener') === -1) {
      rel.push('noopener');
    }

    anchor.setAttribute('rel', rel.join(' '));
  }

  function processLink(anchor, internalHosts) {
    if (!anchor || anchor.hasAttribute('data-o16-external-processed')) return;

    var href = anchor.getAttribute('href');
    if (!href) return;

    // Already has an explicit target — respect the author's choice.
    if (anchor.getAttribute('target')) {
      anchor.setAttribute('data-o16-external-processed', 'true');
      return;
    }

    var url;
    try {
      url = new URL(href, window.location.href);
    } catch (e) {
      return;
    }

    // Only http/https navigations qualify; skip mailto:, tel:, #anchors,
    // javascript:, etc.
    if (url.protocol !== 'http:' && url.protocol !== 'https:') {
      anchor.setAttribute('data-o16-external-processed', 'true');
      return;
    }

    var host = url.host.toLowerCase();
    if (internalHosts.indexOf(host) !== -1) {
      anchor.setAttribute('data-o16-external-processed', 'true');
      return;
    }

    anchor.setAttribute('target', '_blank');
    mergeRelNoopener(anchor);
    anchor.setAttribute('data-o16-external-processed', 'true');
  }

  function processAllLinks() {
    if (window.O16_EXTERNAL_NEW_TAB === false) return;

    var internalHosts = getInternalHosts();
    var anchors = document.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      processLink(anchors[i], internalHosts);
    }
  }

  document.addEventListener('DOMContentLoaded', processAllLinks);
  document.addEventListener('shopify:section:load', processAllLinks);
})();
